import React, { useContext } from "react";
import { Button, Box, Typography, Tooltip } from "@mui/material";
import { CartContext } from "../context/CartContext";

const TimeSlotButton = ({ timeSlot }) => {
  const { addToCart, cartItems } = useContext(CartContext);

  const handleClick = () => {
    addToCart({ ...timeSlot });
  };

  const isSelected = cartItems.some(
    (cartItem) =>
      cartItem.courtId === timeSlot.courtId &&
      cartItem.timeId === timeSlot.timeId &&
      cartItem.sport === timeSlot.sport &&
      cartItem.date === timeSlot.date &&
      cartItem.selected
  );

  return (
    <Tooltip title="Spustelėkite, kad įdėtumėte į krepšelį" arrow>
      <Button
        fullWidth
        sx={{
          outline: "none",
          minHeight: { xs: "40px", sm: "50px" },
          minWidth: { xs: "70px", sm: "90px" },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: { xs: "4px", sm: "8px" },
          backgroundColor: isSelected ? "#156596" : "transparent",
          color: isSelected ? "#fff" : "#156596",
          border: "1px solid #156596",
          "&:hover": {
            backgroundColor: "#3db5ff",
            color: "#fff",
            transform: "scale(1.02)",
            transition: "all 0.2s ease-in-out",
          },
          "&:active": {
            transform: "scale(0.98)",
          },
        }}
        variant={isSelected ? "contained" : "outlined"}
        onClick={handleClick}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: "2px", sm: "4px" },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "0.9rem", sm: "1.1rem" },
              lineHeight: 1,
            }}
          >
            {Number(timeSlot.price)} €
          </Typography>
          <Typography
            variant="caption"
            sx={{
              opacity: 0.8,
              fontSize: { xs: "0.7rem", sm: "0.8rem" },
              lineHeight: 1,
            }}
          >
            {timeSlot.duration} min
          </Typography>
        </Box>
      </Button>
    </Tooltip>
  );
};

export default TimeSlotButton;
